<template>
  <div>
    <div v-bind:class="{ header: type, hero: !type }">
      <div class="absolute z-10">
        <h3
          v-if="subheadline"
          class="text-sm sm:text-xl pb-2 font-normal text-white uppercase tracking-widest"
        >
          {{ subheadline }}
        </h3>
        <h1
          v-if="headline"
          class="text-white text-4xl sm:text-6xl leading-tight font-serif"
        >
          {{ headline }}
        </h1>
        <p v-if="intro">{{ intro }}</p>
      </div>
      <!-- <div class="lazyload" :data-bg="getImgUrl(this.src)"></div> -->
      <div
        :style="bgImage"
        v-bind:class="{ headerImage: type, heroImage: !type }"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Hero',
  props: {
    headline: String,
    subheadline: String,
    intro: String,
    type: String,
    src: String,
    focuspoint: String,
  },
  methods: {
    getImgUrl(img) {
      return require('../assets/' + img)
    },
  },
  computed: {
    bgImage() {
      return `background-image: url(${this.getImgUrl(this.src)})`
    },
  },
}
</script>
<style>
.heroImage {
  @apply w-screen bg-gray-300 h-screen opacity-75 bg-cover bg-center;
}
.header {
  height: 80vh;
  @apply w-full flex relative bg-black items-center justify-center text-center;
}
.headerImage {
  height: 80vh;
  @apply w-screen opacity-75 bg-cover bg-center;
}
.hero {
  @apply h-screen w-full flex relative bg-black items-center justify-center text-center;
}
</style>
